exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".tech-docs {\n  margin-top: 10px;\n  max-height: calc(100vh - 170px);\n  overflow: auto; }\n  .tech-docs .table-box {\n    max-height: calc(100vh - 300px); }\n  .tech-docs .mb-first-line {\n    margin-bottom: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/products/edit/techDocs/TechnicalDocuments.scss
// module id = 1382
// module chunks = 0